/* ==========================================================================
   Monttco — cookie consent. Banner (Aceitar todos / Rejeitar cookies não
   necessários / Gerenciar preferências) + preferences panel, following the
   categories in the Política de Privacidade e Cookies. The choice is stored
   in localStorage ('montt_cookie_consent'); "Gerenciar Cookies" in the
   footer (and any [data-cookie-open]) reopens the panel at any time.
   Other scripts should gate non-essential tools on:
     window.MonttCookies.allowed('analytics' | 'marketing' | 'functional')
   and/or listen for the 'montt:consent' event.
   ========================================================================== */
(function(){
  "use strict";
  var KEY = 'montt_cookie_consent';
  var CATS = [
    { id:'necessary', title:'Cookies necessários', locked:true,
      desc:'São essenciais para o funcionamento do site e da experiência de compra: gerenciar sessões, manter produtos no carrinho, permitir o checkout, garantir segurança e registrar escolhas de cookies.' },
    { id:'functional', title:'Cookies de funcionalidade',
      desc:'Permitem lembrar determinadas preferências e escolhas realizadas durante a navegação.' },
    { id:'analytics', title:'Cookies analíticos e de desempenho',
      desc:'Nos ajudam a compreender como os usuários interagem com nosso site: número de visitantes, páginas mais acessadas, tempo de permanência, origem dos acessos, interações e desempenho.' },
    { id:'marketing', title:'Cookies de publicidade e marketing',
      desc:'Podem ser utilizados para mensurar campanhas, compreender conversões e tornar conteúdos publicitários mais relevantes.' }
  ];

  function read(){
    try { var v = JSON.parse(localStorage.getItem(KEY)); return v && typeof v === 'object' ? v : null; } catch(e){ return null; }
  }
  /* Best-effort hand-off to Shopify's Customer Privacy API (only if the store has it loaded). */
  function shopifyConsent(c){
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') {
        cp.setTrackingConsent({ analytics: c.analytics, marketing: c.marketing, preferences: c.functional, sale_of_data: c.marketing }, function(){});
      }
    } catch(e){}
  }
  function save(prefs){
    var c = { necessary:true, functional:!!prefs.functional, analytics:!!prefs.analytics, marketing:!!prefs.marketing, ts:new Date().toISOString() };
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch(e){}
    shopifyConsent(c);
    try { document.dispatchEvent(new CustomEvent('montt:consent', { detail:c })); } catch(e){}
    return c;
  }

  var root = document.createElement('div');
  root.id = 'cookieConsent';
  root.setAttribute('hidden','');
  root.innerHTML =
    '<div class="ck-bar" role="dialog" aria-modal="false" aria-label="Aviso de cookies">' +
      '<p class="ck-desc">Ao navegar por este site <strong>você aceita o uso de cookies</strong> para agilizar sua experiência de compra. ' +
        '<button type="button" class="ck-link" data-ck="manage">Gerenciar preferências</button></p>' +
      '<button type="button" class="ck-btn ck-btn-solid" data-ck="accept">Aceitar todos</button>' +
    '</div>' +
    '<div class="ck-panel" role="dialog" aria-modal="true" aria-labelledby="ckPanelTitle" hidden>' +
      '<div class="ck-panel-box">' +
        '<p class="ck-title" id="ckPanelTitle">Gerenciar preferências de cookies</p>' +
        '<p class="ck-desc">Cookies necessários permanecem ativos porque são essenciais para o site. Os demais só são ativados com a sua autorização.</p>' +
        '<div class="ck-cats">' +
        CATS.map(function(c){
          return '<label class="ck-cat">' +
            '<span class="ck-cat-head"><span class="ck-cat-title">' + c.title + '</span>' +
            '<input type="checkbox" data-cat="' + c.id + '"' + (c.locked ? ' checked disabled' : '') + '>' +
            '<span class="ck-switch" aria-hidden="true"></span></span>' +
            '<span class="ck-cat-desc">' + c.desc + '</span></label>';
        }).join('') +
        '</div>' +
        '<div class="ck-actions">' +
          '<button type="button" class="ck-btn ck-btn-solid" data-ck="save">Salvar preferências</button>' +
          '<button type="button" class="ck-btn ck-btn-line" data-ck="accept">Aceitar todos</button>' +
          '<button type="button" class="ck-btn ck-btn-link" data-ck="reject">Rejeitar não necessários</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  document.body.appendChild(root);

  var bar = root.querySelector('.ck-bar');
  var panel = root.querySelector('.ck-panel');

  function showBar(){ root.removeAttribute('hidden'); bar.removeAttribute('hidden'); panel.setAttribute('hidden',''); }
  function showPanel(){
    var c = read() || {};
    root.querySelectorAll('input[data-cat]').forEach(function(i){ if (!i.disabled) i.checked = !!c[i.getAttribute('data-cat')]; });
    root.removeAttribute('hidden'); bar.setAttribute('hidden',''); panel.removeAttribute('hidden');
    var f = panel.querySelector('button'); if (f) f.focus();
  }
  function close(){ root.setAttribute('hidden',''); }

  root.addEventListener('click', function(e){
    var b = e.target.closest('[data-ck]'); if (!b) return;
    var a = b.getAttribute('data-ck');
    if (a === 'accept') { save({ functional:true, analytics:true, marketing:true }); close(); }
    else if (a === 'reject') { save({}); close(); }
    else if (a === 'manage') { showPanel(); }
    else if (a === 'save') {
      var p = {}; root.querySelectorAll('input[data-cat]').forEach(function(i){ p[i.getAttribute('data-cat')] = i.checked; });
      save(p); close();
    }
  });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !panel.hasAttribute('hidden') && read()) close(); });
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-cookie-open]'); if (!t) return;
    e.preventDefault(); showPanel();
  });

  window.MonttCookies = {
    open: showPanel,
    get: read,
    allowed: function(cat){ var c = read(); return cat === 'necessary' ? true : !!(c && c[cat]); }
  };

  if (!read()) showBar();
})();
